var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileSvgCheckist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list-plus",
    transform: "translate(0 -0.333)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 51,
    height: 51,
    transform: "translate(0 0.333)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_15",
    "data-name": "Line 15",
    d: "M29.112-4.773h-35.5A1.614,1.614,0,0,1-8-6.386,1.614,1.614,0,0,1-6.386-8h35.5a1.614,1.614,0,0,1,1.614,1.614A1.614,1.614,0,0,1,29.112-4.773Z",
    transform: "translate(14.454 18.994)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_16",
    "data-name": "Line 16",
    d: "M29.112-4.773h-35.5A1.614,1.614,0,0,1-8-6.386,1.614,1.614,0,0,1-6.386-8h35.5a1.614,1.614,0,0,1,1.614,1.614A1.614,1.614,0,0,1,29.112-4.773Z",
    transform: "translate(14.454 31.903)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_17",
    "data-name": "Line 17",
    d: "M14.59-4.773H-6.386A1.614,1.614,0,0,1-8-6.386,1.614,1.614,0,0,1-6.386-8H14.59A1.614,1.614,0,0,1,16.2-6.386,1.614,1.614,0,0,1,14.59-4.773Z",
    transform: "translate(14.454 44.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_18",
    "data-name": "Line 18",
    d: "M3.295-4.773H-6.386A1.614,1.614,0,0,1-8-6.386,1.614,1.614,0,0,1-6.386-8H3.295A1.614,1.614,0,0,1,4.908-6.386,1.614,1.614,0,0,1,3.295-4.773Z",
    transform: "translate(43.498 44.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_19",
    "data-name": "Line 19",
    d: "M-6.386,4.908A1.614,1.614,0,0,1-8,3.295V-6.386A1.614,1.614,0,0,1-6.386-8,1.614,1.614,0,0,1-4.773-6.386V3.295A1.614,1.614,0,0,1-6.386,4.908Z",
    transform: "translate(48.339 39.971)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSvgCheckist);
export default __webpack_public_path__ + "static/media/file_svg_checkist.ab0e0666e44c28619bf6b79e17d68a88.svg";
export { ForwardRef as ReactComponent };